/* eslint-disable */

// @ts-nocheck

// noinspection JSUnusedGlobalSymbols

// This file was automatically generated by TanStack Router.
// You should NOT make any changes in this file as it will be overwritten.
// Additionally, you should also exclude this file from your linter and/or formatter to prevent it from being checked or modified.

import { Route as rootRouteImport } from './routes/__root'
import { Route as VerifyEmailRouteImport } from './routes/verify-email'
import { Route as TermsOfServiceRouteImport } from './routes/terms-of-service'
import { Route as PrivacyPolicyRouteImport } from './routes/privacy-policy'
import { Route as OnboardingRouteImport } from './routes/onboarding'
import { Route as UnauthRedirectRouteRouteImport } from './routes/_unauthRedirect/route'
import { Route as DashboardRouteRouteImport } from './routes/_dashboard/route'
import { Route as DashboardIndexRouteImport } from './routes/_dashboard/index'
import { Route as DashboardUpcomingFeaturesRouteImport } from './routes/_dashboard/upcoming-features'
import { Route as DashboardBillingRouteImport } from './routes/_dashboard/billing'
import { Route as DashboardSettingsRouteRouteImport } from './routes/_dashboard/settings/route'
import { Route as UnauthRedirectSignupIndexRouteImport } from './routes/_unauthRedirect/signup/index'
import { Route as UnauthRedirectSigninIndexRouteImport } from './routes/_unauthRedirect/signin/index'
import { Route as DashboardWriteIndexRouteImport } from './routes/_dashboard/write/index'
import { Route as DashboardSettingsIndexRouteImport } from './routes/_dashboard/settings/index'
import { Route as DashboardScheduleIndexRouteImport } from './routes/_dashboard/schedule/index'
import { Route as DashboardCreateBusinessIndexRouteImport } from './routes/_dashboard/create-business/index'
import { Route as DashboardBusinessInfoIndexRouteImport } from './routes/_dashboard/business-info/index'
import { Route as DashboardBacklinkExchangeIndexRouteImport } from './routes/_dashboard/backlink-exchange/index'
import { Route as DashboardArticlesIndexRouteImport } from './routes/_dashboard/articles/index'
import { Route as DashboardAnalyticsIndexRouteImport } from './routes/_dashboard/analytics/index'
import { Route as DashboardWriteManualRouteImport } from './routes/_dashboard/write/manual'
import { Route as DashboardWriteAiRouteImport } from './routes/_dashboard/write/ai'
import { Route as DashboardSubscriptionSuccessRouteImport } from './routes/_dashboard/subscription.success'
import { Route as DashboardSettingsBusinessRouteImport } from './routes/_dashboard/settings/business'
import { Route as DashboardEditArticleIdRouteImport } from './routes/_dashboard/edit.$articleId'
import { Route as DashboardArticleArticleIdRouteImport } from './routes/_dashboard/article.$articleId'
import { Route as DashboardSettingsIntegrationsRouteRouteImport } from './routes/_dashboard/settings/integrations/route'
import { Route as DashboardSettingsIntegrationsIndexRouteImport } from './routes/_dashboard/settings/integrations/index'
import { Route as DashboardSettingsIntegrationsWordpressRouteImport } from './routes/_dashboard/settings/integrations/wordpress'
import { Route as DashboardSettingsIntegrationsWixRouteImport } from './routes/_dashboard/settings/integrations/wix'
import { Route as DashboardSettingsIntegrationsShopifyRouteImport } from './routes/_dashboard/settings/integrations/shopify'
import { Route as DashboardSettingsIntegrationsFramerRouteImport } from './routes/_dashboard/settings/integrations/framer'
import { Route as DashboardSettingsIntegrationsCustomRouteImport } from './routes/_dashboard/settings/integrations/custom'

const VerifyEmailRoute = VerifyEmailRouteImport.update({
  id: '/verify-email',
  path: '/verify-email',
  getParentRoute: () => rootRouteImport,
} as any)
const TermsOfServiceRoute = TermsOfServiceRouteImport.update({
  id: '/terms-of-service',
  path: '/terms-of-service',
  getParentRoute: () => rootRouteImport,
} as any)
const PrivacyPolicyRoute = PrivacyPolicyRouteImport.update({
  id: '/privacy-policy',
  path: '/privacy-policy',
  getParentRoute: () => rootRouteImport,
} as any)
const OnboardingRoute = OnboardingRouteImport.update({
  id: '/onboarding',
  path: '/onboarding',
  getParentRoute: () => rootRouteImport,
} as any)
const UnauthRedirectRouteRoute = UnauthRedirectRouteRouteImport.update({
  id: '/_unauthRedirect',
  getParentRoute: () => rootRouteImport,
} as any)
const DashboardRouteRoute = DashboardRouteRouteImport.update({
  id: '/_dashboard',
  getParentRoute: () => rootRouteImport,
} as any)
const DashboardIndexRoute = DashboardIndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => DashboardRouteRoute,
} as any)
const DashboardUpcomingFeaturesRoute =
  DashboardUpcomingFeaturesRouteImport.update({
    id: '/upcoming-features',
    path: '/upcoming-features',
    getParentRoute: () => DashboardRouteRoute,
  } as any)
const DashboardBillingRoute = DashboardBillingRouteImport.update({
  id: '/billing',
  path: '/billing',
  getParentRoute: () => DashboardRouteRoute,
} as any)
const DashboardSettingsRouteRoute = DashboardSettingsRouteRouteImport.update({
  id: '/settings',
  path: '/settings',
  getParentRoute: () => DashboardRouteRoute,
} as any)
const UnauthRedirectSignupIndexRoute =
  UnauthRedirectSignupIndexRouteImport.update({
    id: '/signup/',
    path: '/signup/',
    getParentRoute: () => UnauthRedirectRouteRoute,
  } as any)
const UnauthRedirectSigninIndexRoute =
  UnauthRedirectSigninIndexRouteImport.update({
    id: '/signin/',
    path: '/signin/',
    getParentRoute: () => UnauthRedirectRouteRoute,
  } as any)
const DashboardWriteIndexRoute = DashboardWriteIndexRouteImport.update({
  id: '/write/',
  path: '/write/',
  getParentRoute: () => DashboardRouteRoute,
} as any)
const DashboardSettingsIndexRoute = DashboardSettingsIndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => DashboardSettingsRouteRoute,
} as any)
const DashboardScheduleIndexRoute = DashboardScheduleIndexRouteImport.update({
  id: '/schedule/',
  path: '/schedule/',
  getParentRoute: () => DashboardRouteRoute,
} as any)
const DashboardCreateBusinessIndexRoute =
  DashboardCreateBusinessIndexRouteImport.update({
    id: '/create-business/',
    path: '/create-business/',
    getParentRoute: () => DashboardRouteRoute,
  } as any)
const DashboardBusinessInfoIndexRoute =
  DashboardBusinessInfoIndexRouteImport.update({
    id: '/business-info/',
    path: '/business-info/',
    getParentRoute: () => DashboardRouteRoute,
  } as any)
const DashboardBacklinkExchangeIndexRoute =
  DashboardBacklinkExchangeIndexRouteImport.update({
    id: '/backlink-exchange/',
    path: '/backlink-exchange/',
    getParentRoute: () => DashboardRouteRoute,
  } as any)
const DashboardArticlesIndexRoute = DashboardArticlesIndexRouteImport.update({
  id: '/articles/',
  path: '/articles/',
  getParentRoute: () => DashboardRouteRoute,
} as any)
const DashboardAnalyticsIndexRoute = DashboardAnalyticsIndexRouteImport.update({
  id: '/analytics/',
  path: '/analytics/',
  getParentRoute: () => DashboardRouteRoute,
} as any)
const DashboardWriteManualRoute = DashboardWriteManualRouteImport.update({
  id: '/write/manual',
  path: '/write/manual',
  getParentRoute: () => DashboardRouteRoute,
} as any)
const DashboardWriteAiRoute = DashboardWriteAiRouteImport.update({
  id: '/write/ai',
  path: '/write/ai',
  getParentRoute: () => DashboardRouteRoute,
} as any)
const DashboardSubscriptionSuccessRoute =
  DashboardSubscriptionSuccessRouteImport.update({
    id: '/subscription/success',
    path: '/subscription/success',
    getParentRoute: () => DashboardRouteRoute,
  } as any)
const DashboardSettingsBusinessRoute =
  DashboardSettingsBusinessRouteImport.update({
    id: '/business',
    path: '/business',
    getParentRoute: () => DashboardSettingsRouteRoute,
  } as any)
const DashboardEditArticleIdRoute = DashboardEditArticleIdRouteImport.update({
  id: '/edit/$articleId',
  path: '/edit/$articleId',
  getParentRoute: () => DashboardRouteRoute,
} as any)
const DashboardArticleArticleIdRoute =
  DashboardArticleArticleIdRouteImport.update({
    id: '/article/$articleId',
    path: '/article/$articleId',
    getParentRoute: () => DashboardRouteRoute,
  } as any)
const DashboardSettingsIntegrationsRouteRoute =
  DashboardSettingsIntegrationsRouteRouteImport.update({
    id: '/integrations',
    path: '/integrations',
    getParentRoute: () => DashboardSettingsRouteRoute,
  } as any)
const DashboardSettingsIntegrationsIndexRoute =
  DashboardSettingsIntegrationsIndexRouteImport.update({
    id: '/',
    path: '/',
    getParentRoute: () => DashboardSettingsIntegrationsRouteRoute,
  } as any)
const DashboardSettingsIntegrationsWordpressRoute =
  DashboardSettingsIntegrationsWordpressRouteImport.update({
    id: '/wordpress',
    path: '/wordpress',
    getParentRoute: () => DashboardSettingsIntegrationsRouteRoute,
  } as any)
const DashboardSettingsIntegrationsWixRoute =
  DashboardSettingsIntegrationsWixRouteImport.update({
    id: '/wix',
    path: '/wix',
    getParentRoute: () => DashboardSettingsIntegrationsRouteRoute,
  } as any)
const DashboardSettingsIntegrationsShopifyRoute =
  DashboardSettingsIntegrationsShopifyRouteImport.update({
    id: '/shopify',
    path: '/shopify',
    getParentRoute: () => DashboardSettingsIntegrationsRouteRoute,
  } as any)
const DashboardSettingsIntegrationsFramerRoute =
  DashboardSettingsIntegrationsFramerRouteImport.update({
    id: '/framer',
    path: '/framer',
    getParentRoute: () => DashboardSettingsIntegrationsRouteRoute,
  } as any)
const DashboardSettingsIntegrationsCustomRoute =
  DashboardSettingsIntegrationsCustomRouteImport.update({
    id: '/custom',
    path: '/custom',
    getParentRoute: () => DashboardSettingsIntegrationsRouteRoute,
  } as any)

export interface FileRoutesByFullPath {
  '/onboarding': typeof OnboardingRoute
  '/privacy-policy': typeof PrivacyPolicyRoute
  '/terms-of-service': typeof TermsOfServiceRoute
  '/verify-email': typeof VerifyEmailRoute
  '/settings': typeof DashboardSettingsRouteRouteWithChildren
  '/billing': typeof DashboardBillingRoute
  '/upcoming-features': typeof DashboardUpcomingFeaturesRoute
  '/': typeof DashboardIndexRoute
  '/settings/integrations': typeof DashboardSettingsIntegrationsRouteRouteWithChildren
  '/article/$articleId': typeof DashboardArticleArticleIdRoute
  '/edit/$articleId': typeof DashboardEditArticleIdRoute
  '/settings/business': typeof DashboardSettingsBusinessRoute
  '/subscription/success': typeof DashboardSubscriptionSuccessRoute
  '/write/ai': typeof DashboardWriteAiRoute
  '/write/manual': typeof DashboardWriteManualRoute
  '/analytics': typeof DashboardAnalyticsIndexRoute
  '/articles': typeof DashboardArticlesIndexRoute
  '/backlink-exchange': typeof DashboardBacklinkExchangeIndexRoute
  '/business-info': typeof DashboardBusinessInfoIndexRoute
  '/create-business': typeof DashboardCreateBusinessIndexRoute
  '/schedule': typeof DashboardScheduleIndexRoute
  '/settings/': typeof DashboardSettingsIndexRoute
  '/write': typeof DashboardWriteIndexRoute
  '/signin': typeof UnauthRedirectSigninIndexRoute
  '/signup': typeof UnauthRedirectSignupIndexRoute
  '/settings/integrations/custom': typeof DashboardSettingsIntegrationsCustomRoute
  '/settings/integrations/framer': typeof DashboardSettingsIntegrationsFramerRoute
  '/settings/integrations/shopify': typeof DashboardSettingsIntegrationsShopifyRoute
  '/settings/integrations/wix': typeof DashboardSettingsIntegrationsWixRoute
  '/settings/integrations/wordpress': typeof DashboardSettingsIntegrationsWordpressRoute
  '/settings/integrations/': typeof DashboardSettingsIntegrationsIndexRoute
}
export interface FileRoutesByTo {
  '/onboarding': typeof OnboardingRoute
  '/privacy-policy': typeof PrivacyPolicyRoute
  '/terms-of-service': typeof TermsOfServiceRoute
  '/verify-email': typeof VerifyEmailRoute
  '/billing': typeof DashboardBillingRoute
  '/upcoming-features': typeof DashboardUpcomingFeaturesRoute
  '/': typeof DashboardIndexRoute
  '/article/$articleId': typeof DashboardArticleArticleIdRoute
  '/edit/$articleId': typeof DashboardEditArticleIdRoute
  '/settings/business': typeof DashboardSettingsBusinessRoute
  '/subscription/success': typeof DashboardSubscriptionSuccessRoute
  '/write/ai': typeof DashboardWriteAiRoute
  '/write/manual': typeof DashboardWriteManualRoute
  '/analytics': typeof DashboardAnalyticsIndexRoute
  '/articles': typeof DashboardArticlesIndexRoute
  '/backlink-exchange': typeof DashboardBacklinkExchangeIndexRoute
  '/business-info': typeof DashboardBusinessInfoIndexRoute
  '/create-business': typeof DashboardCreateBusinessIndexRoute
  '/schedule': typeof DashboardScheduleIndexRoute
  '/settings': typeof DashboardSettingsIndexRoute
  '/write': typeof DashboardWriteIndexRoute
  '/signin': typeof UnauthRedirectSigninIndexRoute
  '/signup': typeof UnauthRedirectSignupIndexRoute
  '/settings/integrations/custom': typeof DashboardSettingsIntegrationsCustomRoute
  '/settings/integrations/framer': typeof DashboardSettingsIntegrationsFramerRoute
  '/settings/integrations/shopify': typeof DashboardSettingsIntegrationsShopifyRoute
  '/settings/integrations/wix': typeof DashboardSettingsIntegrationsWixRoute
  '/settings/integrations/wordpress': typeof DashboardSettingsIntegrationsWordpressRoute
  '/settings/integrations': typeof DashboardSettingsIntegrationsIndexRoute
}
export interface FileRoutesById {
  __root__: typeof rootRouteImport
  '/_dashboard': typeof DashboardRouteRouteWithChildren
  '/_unauthRedirect': typeof UnauthRedirectRouteRouteWithChildren
  '/onboarding': typeof OnboardingRoute
  '/privacy-policy': typeof PrivacyPolicyRoute
  '/terms-of-service': typeof TermsOfServiceRoute
  '/verify-email': typeof VerifyEmailRoute
  '/_dashboard/settings': typeof DashboardSettingsRouteRouteWithChildren
  '/_dashboard/billing': typeof DashboardBillingRoute
  '/_dashboard/upcoming-features': typeof DashboardUpcomingFeaturesRoute
  '/_dashboard/': typeof DashboardIndexRoute
  '/_dashboard/settings/integrations': typeof DashboardSettingsIntegrationsRouteRouteWithChildren
  '/_dashboard/article/$articleId': typeof DashboardArticleArticleIdRoute
  '/_dashboard/edit/$articleId': typeof DashboardEditArticleIdRoute
  '/_dashboard/settings/business': typeof DashboardSettingsBusinessRoute
  '/_dashboard/subscription/success': typeof DashboardSubscriptionSuccessRoute
  '/_dashboard/write/ai': typeof DashboardWriteAiRoute
  '/_dashboard/write/manual': typeof DashboardWriteManualRoute
  '/_dashboard/analytics/': typeof DashboardAnalyticsIndexRoute
  '/_dashboard/articles/': typeof DashboardArticlesIndexRoute
  '/_dashboard/backlink-exchange/': typeof DashboardBacklinkExchangeIndexRoute
  '/_dashboard/business-info/': typeof DashboardBusinessInfoIndexRoute
  '/_dashboard/create-business/': typeof DashboardCreateBusinessIndexRoute
  '/_dashboard/schedule/': typeof DashboardScheduleIndexRoute
  '/_dashboard/settings/': typeof DashboardSettingsIndexRoute
  '/_dashboard/write/': typeof DashboardWriteIndexRoute
  '/_unauthRedirect/signin/': typeof UnauthRedirectSigninIndexRoute
  '/_unauthRedirect/signup/': typeof UnauthRedirectSignupIndexRoute
  '/_dashboard/settings/integrations/custom': typeof DashboardSettingsIntegrationsCustomRoute
  '/_dashboard/settings/integrations/framer': typeof DashboardSettingsIntegrationsFramerRoute
  '/_dashboard/settings/integrations/shopify': typeof DashboardSettingsIntegrationsShopifyRoute
  '/_dashboard/settings/integrations/wix': typeof DashboardSettingsIntegrationsWixRoute
  '/_dashboard/settings/integrations/wordpress': typeof DashboardSettingsIntegrationsWordpressRoute
  '/_dashboard/settings/integrations/': typeof DashboardSettingsIntegrationsIndexRoute
}
export interface FileRouteTypes {
  fileRoutesByFullPath: FileRoutesByFullPath
  fullPaths:
    | '/onboarding'
    | '/privacy-policy'
    | '/terms-of-service'
    | '/verify-email'
    | '/settings'
    | '/billing'
    | '/upcoming-features'
    | '/'
    | '/settings/integrations'
    | '/article/$articleId'
    | '/edit/$articleId'
    | '/settings/business'
    | '/subscription/success'
    | '/write/ai'
    | '/write/manual'
    | '/analytics'
    | '/articles'
    | '/backlink-exchange'
    | '/business-info'
    | '/create-business'
    | '/schedule'
    | '/settings/'
    | '/write'
    | '/signin'
    | '/signup'
    | '/settings/integrations/custom'
    | '/settings/integrations/framer'
    | '/settings/integrations/shopify'
    | '/settings/integrations/wix'
    | '/settings/integrations/wordpress'
    | '/settings/integrations/'
  fileRoutesByTo: FileRoutesByTo
  to:
    | '/onboarding'
    | '/privacy-policy'
    | '/terms-of-service'
    | '/verify-email'
    | '/billing'
    | '/upcoming-features'
    | '/'
    | '/article/$articleId'
    | '/edit/$articleId'
    | '/settings/business'
    | '/subscription/success'
    | '/write/ai'
    | '/write/manual'
    | '/analytics'
    | '/articles'
    | '/backlink-exchange'
    | '/business-info'
    | '/create-business'
    | '/schedule'
    | '/settings'
    | '/write'
    | '/signin'
    | '/signup'
    | '/settings/integrations/custom'
    | '/settings/integrations/framer'
    | '/settings/integrations/shopify'
    | '/settings/integrations/wix'
    | '/settings/integrations/wordpress'
    | '/settings/integrations'
  id:
    | '__root__'
    | '/_dashboard'
    | '/_unauthRedirect'
    | '/onboarding'
    | '/privacy-policy'
    | '/terms-of-service'
    | '/verify-email'
    | '/_dashboard/settings'
    | '/_dashboard/billing'
    | '/_dashboard/upcoming-features'
    | '/_dashboard/'
    | '/_dashboard/settings/integrations'
    | '/_dashboard/article/$articleId'
    | '/_dashboard/edit/$articleId'
    | '/_dashboard/settings/business'
    | '/_dashboard/subscription/success'
    | '/_dashboard/write/ai'
    | '/_dashboard/write/manual'
    | '/_dashboard/analytics/'
    | '/_dashboard/articles/'
    | '/_dashboard/backlink-exchange/'
    | '/_dashboard/business-info/'
    | '/_dashboard/create-business/'
    | '/_dashboard/schedule/'
    | '/_dashboard/settings/'
    | '/_dashboard/write/'
    | '/_unauthRedirect/signin/'
    | '/_unauthRedirect/signup/'
    | '/_dashboard/settings/integrations/custom'
    | '/_dashboard/settings/integrations/framer'
    | '/_dashboard/settings/integrations/shopify'
    | '/_dashboard/settings/integrations/wix'
    | '/_dashboard/settings/integrations/wordpress'
    | '/_dashboard/settings/integrations/'
  fileRoutesById: FileRoutesById
}
export interface RootRouteChildren {
  DashboardRouteRoute: typeof DashboardRouteRouteWithChildren
  UnauthRedirectRouteRoute: typeof UnauthRedirectRouteRouteWithChildren
  OnboardingRoute: typeof OnboardingRoute
  PrivacyPolicyRoute: typeof PrivacyPolicyRoute
  TermsOfServiceRoute: typeof TermsOfServiceRoute
  VerifyEmailRoute: typeof VerifyEmailRoute
}

declare module '@tanstack/react-router' {
  interface FileRoutesByPath {
    '/verify-email': {
      id: '/verify-email'
      path: '/verify-email'
      fullPath: '/verify-email'
      preLoaderRoute: typeof VerifyEmailRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/terms-of-service': {
      id: '/terms-of-service'
      path: '/terms-of-service'
      fullPath: '/terms-of-service'
      preLoaderRoute: typeof TermsOfServiceRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/privacy-policy': {
      id: '/privacy-policy'
      path: '/privacy-policy'
      fullPath: '/privacy-policy'
      preLoaderRoute: typeof PrivacyPolicyRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/onboarding': {
      id: '/onboarding'
      path: '/onboarding'
      fullPath: '/onboarding'
      preLoaderRoute: typeof OnboardingRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/_unauthRedirect': {
      id: '/_unauthRedirect'
      path: ''
      fullPath: ''
      preLoaderRoute: typeof UnauthRedirectRouteRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/_dashboard': {
      id: '/_dashboard'
      path: ''
      fullPath: ''
      preLoaderRoute: typeof DashboardRouteRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/_dashboard/': {
      id: '/_dashboard/'
      path: '/'
      fullPath: '/'
      preLoaderRoute: typeof DashboardIndexRouteImport
      parentRoute: typeof DashboardRouteRoute
    }
    '/_dashboard/upcoming-features': {
      id: '/_dashboard/upcoming-features'
      path: '/upcoming-features'
      fullPath: '/upcoming-features'
      preLoaderRoute: typeof DashboardUpcomingFeaturesRouteImport
      parentRoute: typeof DashboardRouteRoute
    }
    '/_dashboard/billing': {
      id: '/_dashboard/billing'
      path: '/billing'
      fullPath: '/billing'
      preLoaderRoute: typeof DashboardBillingRouteImport
      parentRoute: typeof DashboardRouteRoute
    }
    '/_dashboard/settings': {
      id: '/_dashboard/settings'
      path: '/settings'
      fullPath: '/settings'
      preLoaderRoute: typeof DashboardSettingsRouteRouteImport
      parentRoute: typeof DashboardRouteRoute
    }
    '/_unauthRedirect/signup/': {
      id: '/_unauthRedirect/signup/'
      path: '/signup'
      fullPath: '/signup'
      preLoaderRoute: typeof UnauthRedirectSignupIndexRouteImport
      parentRoute: typeof UnauthRedirectRouteRoute
    }
    '/_unauthRedirect/signin/': {
      id: '/_unauthRedirect/signin/'
      path: '/signin'
      fullPath: '/signin'
      preLoaderRoute: typeof UnauthRedirectSigninIndexRouteImport
      parentRoute: typeof UnauthRedirectRouteRoute
    }
    '/_dashboard/write/': {
      id: '/_dashboard/write/'
      path: '/write'
      fullPath: '/write'
      preLoaderRoute: typeof DashboardWriteIndexRouteImport
      parentRoute: typeof DashboardRouteRoute
    }
    '/_dashboard/settings/': {
      id: '/_dashboard/settings/'
      path: '/'
      fullPath: '/settings/'
      preLoaderRoute: typeof DashboardSettingsIndexRouteImport
      parentRoute: typeof DashboardSettingsRouteRoute
    }
    '/_dashboard/schedule/': {
      id: '/_dashboard/schedule/'
      path: '/schedule'
      fullPath: '/schedule'
      preLoaderRoute: typeof DashboardScheduleIndexRouteImport
      parentRoute: typeof DashboardRouteRoute
    }
    '/_dashboard/create-business/': {
      id: '/_dashboard/create-business/'
      path: '/create-business'
      fullPath: '/create-business'
      preLoaderRoute: typeof DashboardCreateBusinessIndexRouteImport
      parentRoute: typeof DashboardRouteRoute
    }
    '/_dashboard/business-info/': {
      id: '/_dashboard/business-info/'
      path: '/business-info'
      fullPath: '/business-info'
      preLoaderRoute: typeof DashboardBusinessInfoIndexRouteImport
      parentRoute: typeof DashboardRouteRoute
    }
    '/_dashboard/backlink-exchange/': {
      id: '/_dashboard/backlink-exchange/'
      path: '/backlink-exchange'
      fullPath: '/backlink-exchange'
      preLoaderRoute: typeof DashboardBacklinkExchangeIndexRouteImport
      parentRoute: typeof DashboardRouteRoute
    }
    '/_dashboard/articles/': {
      id: '/_dashboard/articles/'
      path: '/articles'
      fullPath: '/articles'
      preLoaderRoute: typeof DashboardArticlesIndexRouteImport
      parentRoute: typeof DashboardRouteRoute
    }
    '/_dashboard/analytics/': {
      id: '/_dashboard/analytics/'
      path: '/analytics'
      fullPath: '/analytics'
      preLoaderRoute: typeof DashboardAnalyticsIndexRouteImport
      parentRoute: typeof DashboardRouteRoute
    }
    '/_dashboard/write/manual': {
      id: '/_dashboard/write/manual'
      path: '/write/manual'
      fullPath: '/write/manual'
      preLoaderRoute: typeof DashboardWriteManualRouteImport
      parentRoute: typeof DashboardRouteRoute
    }
    '/_dashboard/write/ai': {
      id: '/_dashboard/write/ai'
      path: '/write/ai'
      fullPath: '/write/ai'
      preLoaderRoute: typeof DashboardWriteAiRouteImport
      parentRoute: typeof DashboardRouteRoute
    }
    '/_dashboard/subscription/success': {
      id: '/_dashboard/subscription/success'
      path: '/subscription/success'
      fullPath: '/subscription/success'
      preLoaderRoute: typeof DashboardSubscriptionSuccessRouteImport
      parentRoute: typeof DashboardRouteRoute
    }
    '/_dashboard/settings/business': {
      id: '/_dashboard/settings/business'
      path: '/business'
      fullPath: '/settings/business'
      preLoaderRoute: typeof DashboardSettingsBusinessRouteImport
      parentRoute: typeof DashboardSettingsRouteRoute
    }
    '/_dashboard/edit/$articleId': {
      id: '/_dashboard/edit/$articleId'
      path: '/edit/$articleId'
      fullPath: '/edit/$articleId'
      preLoaderRoute: typeof DashboardEditArticleIdRouteImport
      parentRoute: typeof DashboardRouteRoute
    }
    '/_dashboard/article/$articleId': {
      id: '/_dashboard/article/$articleId'
      path: '/article/$articleId'
      fullPath: '/article/$articleId'
      preLoaderRoute: typeof DashboardArticleArticleIdRouteImport
      parentRoute: typeof DashboardRouteRoute
    }
    '/_dashboard/settings/integrations': {
      id: '/_dashboard/settings/integrations'
      path: '/integrations'
      fullPath: '/settings/integrations'
      preLoaderRoute: typeof DashboardSettingsIntegrationsRouteRouteImport
      parentRoute: typeof DashboardSettingsRouteRoute
    }
    '/_dashboard/settings/integrations/': {
      id: '/_dashboard/settings/integrations/'
      path: '/'
      fullPath: '/settings/integrations/'
      preLoaderRoute: typeof DashboardSettingsIntegrationsIndexRouteImport
      parentRoute: typeof DashboardSettingsIntegrationsRouteRoute
    }
    '/_dashboard/settings/integrations/wordpress': {
      id: '/_dashboard/settings/integrations/wordpress'
      path: '/wordpress'
      fullPath: '/settings/integrations/wordpress'
      preLoaderRoute: typeof DashboardSettingsIntegrationsWordpressRouteImport
      parentRoute: typeof DashboardSettingsIntegrationsRouteRoute
    }
    '/_dashboard/settings/integrations/wix': {
      id: '/_dashboard/settings/integrations/wix'
      path: '/wix'
      fullPath: '/settings/integrations/wix'
      preLoaderRoute: typeof DashboardSettingsIntegrationsWixRouteImport
      parentRoute: typeof DashboardSettingsIntegrationsRouteRoute
    }
    '/_dashboard/settings/integrations/shopify': {
      id: '/_dashboard/settings/integrations/shopify'
      path: '/shopify'
      fullPath: '/settings/integrations/shopify'
      preLoaderRoute: typeof DashboardSettingsIntegrationsShopifyRouteImport
      parentRoute: typeof DashboardSettingsIntegrationsRouteRoute
    }
    '/_dashboard/settings/integrations/framer': {
      id: '/_dashboard/settings/integrations/framer'
      path: '/framer'
      fullPath: '/settings/integrations/framer'
      preLoaderRoute: typeof DashboardSettingsIntegrationsFramerRouteImport
      parentRoute: typeof DashboardSettingsIntegrationsRouteRoute
    }
    '/_dashboard/settings/integrations/custom': {
      id: '/_dashboard/settings/integrations/custom'
      path: '/custom'
      fullPath: '/settings/integrations/custom'
      preLoaderRoute: typeof DashboardSettingsIntegrationsCustomRouteImport
      parentRoute: typeof DashboardSettingsIntegrationsRouteRoute
    }
  }
}

interface DashboardSettingsIntegrationsRouteRouteChildren {
  DashboardSettingsIntegrationsCustomRoute: typeof DashboardSettingsIntegrationsCustomRoute
  DashboardSettingsIntegrationsFramerRoute: typeof DashboardSettingsIntegrationsFramerRoute
  DashboardSettingsIntegrationsShopifyRoute: typeof DashboardSettingsIntegrationsShopifyRoute
  DashboardSettingsIntegrationsWixRoute: typeof DashboardSettingsIntegrationsWixRoute
  DashboardSettingsIntegrationsWordpressRoute: typeof DashboardSettingsIntegrationsWordpressRoute
  DashboardSettingsIntegrationsIndexRoute: typeof DashboardSettingsIntegrationsIndexRoute
}

const DashboardSettingsIntegrationsRouteRouteChildren: DashboardSettingsIntegrationsRouteRouteChildren =
  {
    DashboardSettingsIntegrationsCustomRoute:
      DashboardSettingsIntegrationsCustomRoute,
    DashboardSettingsIntegrationsFramerRoute:
      DashboardSettingsIntegrationsFramerRoute,
    DashboardSettingsIntegrationsShopifyRoute:
      DashboardSettingsIntegrationsShopifyRoute,
    DashboardSettingsIntegrationsWixRoute:
      DashboardSettingsIntegrationsWixRoute,
    DashboardSettingsIntegrationsWordpressRoute:
      DashboardSettingsIntegrationsWordpressRoute,
    DashboardSettingsIntegrationsIndexRoute:
      DashboardSettingsIntegrationsIndexRoute,
  }

const DashboardSettingsIntegrationsRouteRouteWithChildren =
  DashboardSettingsIntegrationsRouteRoute._addFileChildren(
    DashboardSettingsIntegrationsRouteRouteChildren,
  )

interface DashboardSettingsRouteRouteChildren {
  DashboardSettingsIntegrationsRouteRoute: typeof DashboardSettingsIntegrationsRouteRouteWithChildren
  DashboardSettingsBusinessRoute: typeof DashboardSettingsBusinessRoute
  DashboardSettingsIndexRoute: typeof DashboardSettingsIndexRoute
}

const DashboardSettingsRouteRouteChildren: DashboardSettingsRouteRouteChildren =
  {
    DashboardSettingsIntegrationsRouteRoute:
      DashboardSettingsIntegrationsRouteRouteWithChildren,
    DashboardSettingsBusinessRoute: DashboardSettingsBusinessRoute,
    DashboardSettingsIndexRoute: DashboardSettingsIndexRoute,
  }

const DashboardSettingsRouteRouteWithChildren =
  DashboardSettingsRouteRoute._addFileChildren(
    DashboardSettingsRouteRouteChildren,
  )

interface DashboardRouteRouteChildren {
  DashboardSettingsRouteRoute: typeof DashboardSettingsRouteRouteWithChildren
  DashboardBillingRoute: typeof DashboardBillingRoute
  DashboardUpcomingFeaturesRoute: typeof DashboardUpcomingFeaturesRoute
  DashboardIndexRoute: typeof DashboardIndexRoute
  DashboardArticleArticleIdRoute: typeof DashboardArticleArticleIdRoute
  DashboardEditArticleIdRoute: typeof DashboardEditArticleIdRoute
  DashboardSubscriptionSuccessRoute: typeof DashboardSubscriptionSuccessRoute
  DashboardWriteAiRoute: typeof DashboardWriteAiRoute
  DashboardWriteManualRoute: typeof DashboardWriteManualRoute
  DashboardAnalyticsIndexRoute: typeof DashboardAnalyticsIndexRoute
  DashboardArticlesIndexRoute: typeof DashboardArticlesIndexRoute
  DashboardBacklinkExchangeIndexRoute: typeof DashboardBacklinkExchangeIndexRoute
  DashboardBusinessInfoIndexRoute: typeof DashboardBusinessInfoIndexRoute
  DashboardCreateBusinessIndexRoute: typeof DashboardCreateBusinessIndexRoute
  DashboardScheduleIndexRoute: typeof DashboardScheduleIndexRoute
  DashboardWriteIndexRoute: typeof DashboardWriteIndexRoute
}

const DashboardRouteRouteChildren: DashboardRouteRouteChildren = {
  DashboardSettingsRouteRoute: DashboardSettingsRouteRouteWithChildren,
  DashboardBillingRoute: DashboardBillingRoute,
  DashboardUpcomingFeaturesRoute: DashboardUpcomingFeaturesRoute,
  DashboardIndexRoute: DashboardIndexRoute,
  DashboardArticleArticleIdRoute: DashboardArticleArticleIdRoute,
  DashboardEditArticleIdRoute: DashboardEditArticleIdRoute,
  DashboardSubscriptionSuccessRoute: DashboardSubscriptionSuccessRoute,
  DashboardWriteAiRoute: DashboardWriteAiRoute,
  DashboardWriteManualRoute: DashboardWriteManualRoute,
  DashboardAnalyticsIndexRoute: DashboardAnalyticsIndexRoute,
  DashboardArticlesIndexRoute: DashboardArticlesIndexRoute,
  DashboardBacklinkExchangeIndexRoute: DashboardBacklinkExchangeIndexRoute,
  DashboardBusinessInfoIndexRoute: DashboardBusinessInfoIndexRoute,
  DashboardCreateBusinessIndexRoute: DashboardCreateBusinessIndexRoute,
  DashboardScheduleIndexRoute: DashboardScheduleIndexRoute,
  DashboardWriteIndexRoute: DashboardWriteIndexRoute,
}

const DashboardRouteRouteWithChildren = DashboardRouteRoute._addFileChildren(
  DashboardRouteRouteChildren,
)

interface UnauthRedirectRouteRouteChildren {
  UnauthRedirectSigninIndexRoute: typeof UnauthRedirectSigninIndexRoute
  UnauthRedirectSignupIndexRoute: typeof UnauthRedirectSignupIndexRoute
}

const UnauthRedirectRouteRouteChildren: UnauthRedirectRouteRouteChildren = {
  UnauthRedirectSigninIndexRoute: UnauthRedirectSigninIndexRoute,
  UnauthRedirectSignupIndexRoute: UnauthRedirectSignupIndexRoute,
}

const UnauthRedirectRouteRouteWithChildren =
  UnauthRedirectRouteRoute._addFileChildren(UnauthRedirectRouteRouteChildren)

const rootRouteChildren: RootRouteChildren = {
  DashboardRouteRoute: DashboardRouteRouteWithChildren,
  UnauthRedirectRouteRoute: UnauthRedirectRouteRouteWithChildren,
  OnboardingRoute: OnboardingRoute,
  PrivacyPolicyRoute: PrivacyPolicyRoute,
  TermsOfServiceRoute: TermsOfServiceRoute,
  VerifyEmailRoute: VerifyEmailRoute,
}
export const routeTree = rootRouteImport
  ._addFileChildren(rootRouteChildren)
  ._addFileTypes<FileRouteTypes>()
